import { render, staticRenderFns } from "./RealEstateFS.vue?vue&type=template&id=481e61ff&scoped=true"
import script from "./RealEstateFS.vue?vue&type=script&lang=ts"
export * from "./RealEstateFS.vue?vue&type=script&lang=ts"
import style0 from "./RealEstateFS.vue?vue&type=style&index=0&id=481e61ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e61ff",
  null
  
)

export default component.exports